import React from 'react';

// Referência a outra entidade que sempre navega — nunca texto morto (§5/§11
// da rodada de correção pós-QA). Usar em tabelas e em seções CONTEXTO de
// drawers. `onClick` já deve vir com `stopPropagation` resolvido por quem
// chama quando usado dentro de uma linha de tabela clicável.
export function EntityLink({ children, onClick }) {
  return (
    <button type="button" className="crm-entity-link" onClick={onClick}>
      {children}
      <span className="crm-entity-link-chevron">›</span>
    </button>
  );
}

// "Não vinculado" + ação — usado no lugar de deixar um campo relacional
// simplesmente em branco (§4/§10: Cliente/Projeto/Fornecedor não podem
// desaparecer só porque não foram informados na criação).
export function UnlinkedField({ label = 'Não vinculado', actionLabel, onAction }) {
  return (
    <span className="crm-unlinked">
      {label}
      {onAction && (
        <button type="button" className="crm-entity-link" onClick={onAction}>{actionLabel}</button>
      )}
    </span>
  );
}

export default EntityLink;
